/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechPhoneSmartOffIcon16Light } from './TechPhoneSmartOffIcon16Light';
import { TechPhoneSmartOffIcon16Regular } from './TechPhoneSmartOffIcon16Regular';
import { TechPhoneSmartOffIcon16Solid } from './TechPhoneSmartOffIcon16Solid';
import { TechPhoneSmartOffIcon20Light } from './TechPhoneSmartOffIcon20Light';
import { TechPhoneSmartOffIcon20Regular } from './TechPhoneSmartOffIcon20Regular';
import { TechPhoneSmartOffIcon20Solid } from './TechPhoneSmartOffIcon20Solid';
import { TechPhoneSmartOffIcon24Regular } from './TechPhoneSmartOffIcon24Regular';
import { TechPhoneSmartOffIcon24Solid } from './TechPhoneSmartOffIcon24Solid';
import { TechPhoneSmartOffIcon32Regular } from './TechPhoneSmartOffIcon32Regular';
import { TechPhoneSmartOffIcon64Regular } from './TechPhoneSmartOffIcon64Regular';
var sizes = {
    16: {
        light: TechPhoneSmartOffIcon16Light,
        regular: TechPhoneSmartOffIcon16Regular,
        solid: TechPhoneSmartOffIcon16Solid,
    },
    20: {
        light: TechPhoneSmartOffIcon20Light,
        regular: TechPhoneSmartOffIcon20Regular,
        solid: TechPhoneSmartOffIcon20Solid,
    },
    24: {
        regular: TechPhoneSmartOffIcon24Regular,
        solid: TechPhoneSmartOffIcon24Solid,
    },
    32: {
        regular: TechPhoneSmartOffIcon32Regular,
    },
    64: {
        regular: TechPhoneSmartOffIcon64Regular,
    },
};
export var TechPhoneSmartOffIcon = forwardRef('TechPhoneSmartOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
